import {format, parseISO} from 'date-fns';

import Typography from 'components/Typography';

import {File, NoteSort} from 'types';

import styles from './Note.module.scss';
import Avatar from 'components/Avatar';
import {useHistory} from 'react-router-dom';

interface Props {
  text: string;
  created_at: string;
  author: string;
  avatar?: File;
  route_id?: number | null;
  isCompleted: boolean;
  is_visible_to_drivers: boolean;
  isRouteClickable?: boolean;
  id: number;
  note_type?: NoteSort;
}

function Note({
  text,
  author,
  avatar,
  created_at,
  route_id,
  isCompleted,
  is_visible_to_drivers,
  isRouteClickable,
  note_type,
  id,
}: Props) {
  const history = useHistory();

  const payment_url = 'magicdispatch.com/payment?';

  const lasttext = text.includes('Transaction ID')
    ? text.slice(0, text.lastIndexOf('Transaction ID: ') + 15)
    : text.includes(payment_url)
    ? text.slice(0, text.indexOf('payment:') + 9)
    : text;

  const handleRouteClick = () => {
    if (!route_id) return;
    history.push(`/history/routes/${route_id}`);
  };
  return (
    <div className={styles.root}>
      {is_visible_to_drivers && (
        <p className={styles.visible}>Visible to Workers</p>
      )}
      <div className={styles.row_name}>
        <Typography variant="p">
          {lasttext}
          {text.includes(payment_url) && (
            <a
              rel="noreferrer"
              href={`${text.split('payment:')[1]}`}
              target="_blank"
              className={styles.payment_url}
            >
              {text.split('payment: ')[1]}
            </a>
          )}
        </Typography>
        {text.includes('Transaction ID') && (
          <Typography
            onClick={() =>
              history.push(
                `/transactions/${text.split('Transaction ID: ')[1]}`,
                {
                  isRouteHistory: true,
                }
              )
            }
            className={styles.transaction_id}
            variant="p"
          >
            {/* {text.split('Transaction ID: ')[1]} */}
            {id}
          </Typography>
        )}
        {isCompleted && note_type === 'notes' && (
          <Typography
            onClick={handleRouteClick}
            className={styles.route_id}
            variant="p"
          >
            See route
          </Typography>
        )}
        {!isCompleted &&
          isRouteClickable &&
          !!route_id &&
          note_type === 'notes' && (
            <Typography
              onClick={handleRouteClick}
              className={styles.route_id}
              variant="p"
            >
              See route
            </Typography>
          )}
      </div>
      <div className={styles.bottom}>
        <div className={styles.author}>
          <Avatar name={author} file={avatar} size="sm" />
          <span className={styles.author__name}>{author}</span>
        </div>
        <span className={styles.datetime}>
          {format(parseISO(created_at), 'MMMM d Y, h:mm aa')}
        </span>
      </div>
    </div>
  );
}

export default Note;
